import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  DialogActions,
} from '@mui/material';

const ErrorDialog = ({ open, handleClose, message }) => {
  return (
    <Dialog open={open} onClose={handleClose} PaperProps={{ sx: { borderRadius: '28px' } }}>
      <div style={{ backgroundColor: '#FFDAD6' }}>
        <DialogTitle style={{ minWidth: '365px', color: '#BA1A1A', paddingTop: '24px' }}>
          Error
        </DialogTitle>
        <DialogContent style={{ paddingBottom: '0px' }}>
          <DialogContentText style={{ color: 'black', paddingBottom: '0px' }}>
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} style={{ color: '#BA1A1A', padding: '24px' }}>
            Ok
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default ErrorDialog;
